module.exports = __webpack_public_path__ + "img/account_circle.83957aa8.svg";